import { render, staticRenderFns } from "./sub-index.vue?vue&type=template&id=37f051e0&scoped=true"
import script from "./sub-index.vue?vue&type=script&lang=js"
export * from "./sub-index.vue?vue&type=script&lang=js"
import style0 from "./sub-index.vue?vue&type=style&index=0&id=37f051e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f051e0",
  null
  
)

export default component.exports